/**
 * Query keys shared across features. Feature-local keys may live in the feature, but always start with
 * the domain segment so `invalidateQueries({ queryKey: ['crm'] })` refreshes a whole domain.
 */
export const qk = {
  me: ['identity', 'me'] as const,
  statusCatalog: ['platform', 'status-catalog'] as const,
  notifications: ['platform', 'notifications'] as const,
  adminUnits: (version?: string) => ['reference', 'admin-units', version ?? 'current'] as const,
  userLookup: (q: string) => ['identity', 'users', 'lookup', q] as const,
  users: ['identity', 'users'] as const,
  roles: ['identity', 'roles'] as const,
  permissions: ['identity', 'permissions'] as const,
  teams: ['identity', 'teams'] as const,
  delegations: ['identity', 'delegations'] as const,
  documents: (entityType: string, entityId: number) => ['documents', entityType, entityId] as const,
  customers: ['crm', 'customers'] as const,
  customerList: (params: object) => ['crm', 'customers', 'list', params] as const,
  customer: (id: number) => ['crm', 'customers', 'detail', id] as const,
  leads: ['crm', 'leads'] as const,
  opportunities: ['crm', 'opportunities'] as const,
  activities: (relatedType: string, relatedId: number) => ['crm', 'activities', relatedType, relatedId] as const,
  pendingOverrides: ['crm', 'classification-overrides', 'pending'] as const,
  catalog: (name: string) => ['catalog', name] as const,
  audit: (params: object) => ['audit', params] as const,
};
